import { Box, Typography, useTheme, useMediaQuery, IconButton, Button } from "@mui/material";
import {
    HomeOutlined,
    Diversity3,
    ImportExport,
    DevicesOutlined
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
const List = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const isNonMobileScreens = useMediaQuery("(min-width: 1000px)");
    const isMobile = useMediaQuery("(max-width: 768px)");
    const dark = theme.palette.neutral.dark;
    const primaryLight = theme.palette.primary.light;
    return (
        <Box
            width="100%"
            padding="2rem 6%"
            display="flex"
            flexDirection={isNonMobileScreens ? "row" : "column"}
            gap="2rem"
            justifyContent="center"
            flexWrap={isNonMobileScreens ? "wrap" : "nowrap"}
        >
            <Box 
                flexBasis={isNonMobileScreens ? "45%" : undefined}
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap="1rem"
                textAlign="center"
                mb={isMobile ? 2 : 0}
                sx={{
                    background: "rgba(0,0,0,0.0)",
                    borderRadius: "1rem",
                    padding: "1rem",
                    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                    "color": "black"
                }}
            >
                <IconButton>
                    <Diversity3 sx={{ fontSize: "40px" }} style={{ color: "white" }} />
                </IconButton>
                <Typography variant="h6" color="white">
                    Create Your Own Flashcard Decks
                </Typography>
                <Typography variant="h6" sx={{ color: primaryLight }}>
                    Build personalized collections of flashcards for any topic you want to learn - from vocabulary words to math formulas to historical facts. Import existing decks from Anki or start fresh with our easy creator.
                </Typography>
            </Box>
            <Box 
                flexBasis={isNonMobileScreens ? "45%" : undefined}
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap="1rem"
                textAlign="center"
                mb={isMobile ? 2 : 0}
                sx={{
                    background: "rgba(0,0,0,0.0)",
                    borderRadius: "1rem",
                    padding: "1rem",
                    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                    "color": "black"
                }}
            >
                <IconButton>
                    <ImportExport sx={{ fontSize: "40px" }} style={{ color: "white" }} />
                </IconButton>
                <Typography variant="h6" color="white">
                    Study on Your Kindle Device
                </Typography>
                <Typography variant="h6" sx={{ color: primaryLight }}>
                    Bring your flashcards anywhere! Import decks from popular Anki software, customize them in Uben, then export to KAnki format to study on your e-reader while traveling or relaxing.
                </Typography>
            </Box>
            <Box 
                flexBasis={isNonMobileScreens ? "45%" : undefined}
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap="1rem"
                textAlign="center"
                mb={isMobile ? 2 : 0}
                sx={{
                    background: "rgba(0,0,0,0.0)",
                    borderRadius: "1rem",
                    padding: "1rem",
                    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                    "color": "black"
                }}
            >
                <IconButton>
                    <HomeOutlined sx={{ fontSize: "40px" }} style={{ color: "white" }} />
                </IconButton>
                <Typography variant="h6" color="white">
                    Guided Learning Paths
                </Typography>
                <Typography variant="h6" sx={{ color: primaryLight }}>
                    Follow step-by-step learning journeys designed by experts. Each path breaks down complex subjects into manageable lessons that build your knowledge progressively from basics to advanced concepts.
                </Typography>
            </Box>
            <Box 
                flexBasis={isNonMobileScreens ? "45%" : undefined}
                display="flex"
                flexDirection="column"
                alignItems="center"
                gap="1rem"
                textAlign="center"

                sx={{
                    background: "rgba(0,0,0,0.0)",
                    borderRadius: "1rem",
                    padding: "1rem",
                    boxShadow: "0 0 10px rgba(0,0,0,0.1)",
                    "color": "black"
                }}
            >
                <IconButton>
                    <DevicesOutlined sx={{ fontSize: "40px" }} style={{ color: "white" }} />
                </IconButton>
                <Typography variant="h6" color="white">
                    Watch Your Knowledge Grow
                </Typography>
                <Typography variant="h6" sx={{ color: primaryLight }}>
                    See beautiful charts and graphs showing your daily study streaks, cards mastered, time spent learning, and accuracy rates. Stay motivated as you watch your skills improve across all subjects.
                </Typography>
            </Box>
        </Box>
    );
};

export default List;
